'use strict';

import { view } from '@/functions';
const prefix = '/rules';

export default [
    {
        path: prefix,
        name: 'rules',
        meta: {
            title: 'Rules',
            scopes: ['read_rules', 'write_rules'],
        },
        component: () => view('rules/index'),
    },
]
